export default __webpack_public_path__ + "static/media/ico_music.0a339867.svg";